import { TimetableReportType } from '@bp/planung-graphql-types';
import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TimetablePrintConfigurationForm } from '../forms/TimetablePrintConfigurationForm';

type TimetablePrintConfigurationModalProps = {
  isOpen: boolean;
  subType: TimetableReportType;
  onClose: () => void;
};

export const TimetablePrintConfigurationModal = ({
  isOpen,
  subType,
  onClose,
}: TimetablePrintConfigurationModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('timetable.configuration.configure')} isOpen={isOpen} loading={loading} onRequestClose={onClose}>
      <TimetablePrintConfigurationForm subType={subType} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
